import { PRICE_ID_TO_GRAMS } from '@iheartjane/menu';
import type { Nullable, PriceId, ProductKind } from '@iheartjane/types';

import { cartSize } from '@jane/shared-ecomm/util';

export interface CartWeightInput {
  products?: ReadonlyArray<{
    count: number;
    kind: ProductKind;
    price_id: PriceId;
  }>;
}

export const getProductWeightInCart = (cart?: Nullable<CartWeightInput>) => {
  if (!cart || cartSize(cart) === 0) {
    return null;
  }
  const weight = (cart.products ?? []).reduce((totalWeight, product) => {
    if (product.kind === 'flower' && product.price_id !== 'each') {
      return totalWeight + PRICE_ID_TO_GRAMS[product.price_id] * product.count;
    }
    return totalWeight;
  }, 0);
  return weight === 0 ? null : weight;
};
